import { SubscriptionName } from '@anm/api/modules/subscription';

import getOriginSubscriptionName from '../getOriginSubscriptionName';
import isTeamSubscription from '../isTeamSubscription';

export const singlePlanTopList = ['Streamer', 'Creator', 'Business'];

const higherSinglePlanIndex = singlePlanTopList.length - 1;

const check = (list: string[], subscription: SubscriptionName, higherPlanIndex: number) =>
  list.indexOf(getOriginSubscriptionName(subscription)) === higherPlanIndex;

const isSubscriptionHighPlan = (subscription: SubscriptionName) =>
  isTeamSubscription(subscription) ? false : check(singlePlanTopList, subscription, higherSinglePlanIndex);

export default isSubscriptionHighPlan;
